<div class="field">
    @if (label()) {
        <label [for]="inputId()">{{ label() }}</label>
    }
    <cl-input [inputId]="inputId()" [type]="type()" [placeholder]="placeholder()" [formControl]="control()" autocomplete="off" />
    <app-form-error [errors]="control().errors" [visible]="control().touched && !!control().errors" />
</div>
